import React, { type ErrorInfo, type ReactNode } from 'react';
import { Button, Result } from 'antd';
import { logger } from '@/utils/logger';

interface GlobalErrorBoundaryProps {
  children: ReactNode;
}

interface GlobalErrorBoundaryState {
  hasError: boolean;
}

class GlobalErrorBoundary extends React.Component<
  GlobalErrorBoundaryProps,
  GlobalErrorBoundaryState
> {
  state: GlobalErrorBoundaryState = {
    hasError: false,
  };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    logger.error('Global UI error captured', error, {
      componentStack: errorInfo.componentStack,
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <Result
          extra={
            <Button onClick={() => window.location.reload()} type="primary">
              刷新页面
            </Button>
          }
          status="500"
          subTitle="全局异常已被捕获，请刷新后重试。"
          title="应用发生异常"
        />
      );
    }

    return this.props.children;
  }
}

export default GlobalErrorBoundary;
